<div [class]="class">
    <img [src]="image" class="img-fluid" alt="no-data" *ngIf="image">
    <h4>{{ text! | translate }}</h4>
</div>